import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import Select from "react-select";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteWages,
  getWages,
  insertWages,
  getWageTypes,
  getCategorys,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";

export default function Wage() {
  const UID = getSecureItem("userId");
  const [addWageModal, setAddWageModal] = useState(false);
  const [editWageModal, setEditWageModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [wage, setWage] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [commonDatas, setCommonDatas] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categorys, setCategorys] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [WageComponent, setWageComponent] = useState([]);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  useEffect(() => {
    console.log("selectedValues", selectedValues);

  }, [selectedValues])


  const [wagecomponentIdToDelete, setwagecomponentIdToDelete] = useState(null);
  const [wageData, setWageData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    ComponentType: "",
    WageTypeId: "",
    WageComponentId: "",
    Type: "amount",
    Amount: "",
    CategoryId: "",
    UserId: UID,
  });
  const openAddWageModal = () => {
    setAddWageModal(!addWageModal);
    setWageData({
      Id: "",
      Name: "",
      Narration: "",
      ComponentType: "",
      WageTypeId: "",
      Type: "amount",
      Amount: "",
      CategoryId: "",

      UserId: UID,
    });
  };

  const WgCompOptions = WageComponent?.map((center) => ({
    value: center.Id,
    label: center.Name,
  })) || [];

  const openEditWageModal = (data) => {
    // Check if WageTypeId is a string and split it into an array
    const formattedWageTypeId = typeof data?.WageTypeId === 'string'
      ? data.WageTypeId.split(',').map(item => item.trim()) // Split by commas and trim any extra spaces
      : Array.isArray(data?.WageTypeId) ? data.WageTypeId : []; // If already an array, use it; otherwise, fallback to an empty array

    const CommonDataName = commonDatas.find((item) => item.Id == data?.WageComponentId);
    const formattedWageCompId = typeof data?.WageComponentId === 'string'
      ? data.WageComponentId.split(',').map(item => item.trim()) // Split by commas and trim any extra spaces
      : Array.isArray(data?.WageComponentId) ? data.WageComponentId : []; // If already an array, use it; otherwise, fallback to an empty array
    setSelectedValues(formattedWageCompId)
    setEditWageModal(!editWageModal);
    setWageData({
      ...data,
      WageTypeId: formattedWageTypeId, // Set the properly formatted WageTypeId
      CommonDataId: CommonDataName?.Name,
      WageComponentId: formattedWageCompId,
      UserId: UID || "",
    });
  };


  const clearData = () => {
    setWageData({
      Id: "",
      Name: "",
      Narration: "",
      ComponentType: "",
      WageTypeId: "",
      Type: "amount",
      Amount: "",
      CategoryId: "",
      UserId: UID,
    });
  };

  const clearDataedit = () => {
    setWageData((ref) => ({
      ...ref,
      Name: "",
      Narration: "",
      ComponentType: "",
      WageTypeId: "",
      Type: "amount",
      Amount: "",
      CategoryId: "",
      UserId: UID,
    }));
  };

  const fetchWage = async () => {
    try {
      const data = await getWages(UID);
      console.log(data.data.data, "Fetched data");
      setWage(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching wage", error);
    }
    setLoading(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setWageData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeWgComponent = (event) => {
    const { value, checked } = event.target;
    let updatedSelectedValues = [...selectedValues];

    if (checked) {
      // Add the value to the selected values
      updatedSelectedValues.push(value);
    } else {
      // Remove the value from the selected values
      updatedSelectedValues = updatedSelectedValues.filter((id) => id !== value);
    }

    setSelectedValues(updatedSelectedValues);
    console.log("Selected IDs:", updatedSelectedValues);
  };


  // const handleChange = (selectedOptions, name ) => {
  //   const selectedValues = selectedOptions?.map((option) => option.value) || [];
  //   setWageData((prev) => ({
  //     ...prev,
  //     [name]: selectedValues, // Update state with selected values (IDs)
  //   }));
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ...wageData,
      WageComponentId: selectedValues,
    };
    try {
      const response = await insertWages(formData);
      console.log("sjkdfhsk", response);
      if (response.data.data.StatusCode === 200) {
        toast.success(response.data.data.message);
        fetchWage();
        fetchWageComponent();
        openAddWageModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code is already in use. Please use a unique code");
      } else {
        toast.error("Error occurred while adding Wage Component.");
      }
      console.error("Error adding Wage Component:", error);
    } finally {
      setLoading(false);
    }
  };

  // ========================================================edit===========================================================================



  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);


    const formData = {
      ...wageData,
      WageComponentId: selectedValues,
    };

    // Check for mandatory fields
    if (!wageData.Type) {
      toast.error("Please select a Type (Amount or Percentage).");
      setLoading(false);

      return;
    }
    console.log('first if', wageData?.Type);

    // if (wageData?.Type === "percentage" && wageData?.WageTypeId?.length === 0) {
    //   toast.error("Please select at least one Wage Type for Percentage.");
    //   setLoading(false);

    //   return;
    // }
    // console.log('seconf if', wageData.Type, wageData?.WageTypeId.length);
    try {
      const response = await insertWages(formData);
      if (response?.data?.data?.StatusCode === 200) {
        toast.success(response.data.data.message);
        fetchWage();
        fetchWageComponent();

        openEditWageModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code is already in use. Please use a unique code");
      } else {
        toast.error("Error occurred while editing Wage Component.");
      }
      console.error("Error editing Wage Component:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(wageData, "wageData");

  }, [wageData])


  const removeCategory = async (categoryId) => {
    const removeData = { Id: categoryId, TableName: "WageComponents" };

    setLoading(true);
    try {
      const res = await deleteWages(removeData, UID); // Add await here
      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Wage Component Deleted successfully");
          fetchWage();
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Category");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Wage Component.";
        toast.error('Wage Component already using cannot delete');
      } else {
        console.error("Error removing Wage Component:", error);
        toast.error("Error deleting Wage Component. Please try again.");
      }
    }

    setLoading(false);
  };


  const openModal = (wagecomponentId) => {
    setwagecomponentIdToDelete(wagecomponentId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setwagecomponentIdToDelete(null);
  };

  const confirmDelete = () => {
    if (wagecomponentIdToDelete) {
      removeCategory(wagecomponentIdToDelete);
    }
    closeModal();
  };

  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "WageComponent",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: " Type",
      selector: (row) => row.Type,
      sortable: true,
    },
    // {
    //   name: "Category ",
    //   // selector: (row) => row.CategoryName,
    //   // sortable: true,
    //   selector: (row) => {
    //     const category = categorys?.find((el) => el.Id === row.CategoryId);


    //     return category ? category.Name : "N/A"; // Handle case where category is not found
    //   },
    // },
    {
      name: "Amount/Percentage",
      selector: (row) => row.Amount,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditWageModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const filteredItems = dataFilter.filter(
    (item) =>
      // item.Id.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Type?.toLowerCase().includes(filterText.toLowerCase())||
      (item.Amount?.toString().toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {

  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    const fetchCommonDatas = async () => {
      try {
        const response = await getWageTypes(UID);

        setCommonDatas(response.data.data);
        console.log(commonDatas, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchCommonDatas();
  }, []);

  
    const fetchWageComponent = async () => {
      try {
        const response = await getWages(UID);

        setWageComponent(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };


  useEffect(() => {
    setLoading(true);
    fetchWage();
    fetchWageComponent()
  }, []);

  useEffect(() => {
    if (wage && wage.length > 0) {
      const updatedData = wage.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        ComponentType: item.ComponentType || "",
        WageTypeId: item.WageTypeId || "",
        Type: item.Type || "",
        Amount: item.Amount || "",
        CategoryId: item.CategoryId || '',
        WageComponentId: item.WageComponentId || ''
      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [wage]);

  useEffect(() => {
    const fetchCategorys = async () => {
      try {
        const response = await getCategorys(UID);

        setCategorys(response.data.data);
        console.log(categorys, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchCategorys();
  }, []);



  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };
  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Wage Component?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Wage Component" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by WageComponent/Type/Amount"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddWageModal}
            // disabled
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>

      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={wage} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {addWageModal && (
        <>
          <div className="fixed p-15 w-full max-w-[900px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Wage Component
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddWageModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleSubmit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px]"
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[70vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-2 gap-8"> {/* Two-column layout */}
                    <div className="form-group flex flex-col">
                      <label>
                        Wagecomponent<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={wageData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>


                    <div className="form-group flex flex-col">
                      <label>
                        Component type <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="ComponentType"
                        value={wageData.ComponentType}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select Component Type
                        </option>
                        <option value="Deduction type">Deduction Type</option>
                        <option value="Addition type">Addition Type</option>
                      </select>
                    </div>

                    {/* <div className="form-group flex flex-col">
                      <label>
                        Category <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="CategoryId"
                        value={wageData.CategoryId || ""}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select Category
                        </option>
                        {categorys.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    <div className="form-group flex flex-col"> {/* Full-width field */}
                      <label>
                        Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="mb-3">
                        <select
                          id="wageType"
                          name="Type"
                          value={wageData.Type}
                          onChange={(e) => {
                            const selectedType = e.target.value;
                            handleChange(e);

                            // Automatically set the WageTypeId when "Percentage" is selected
                            if (selectedType === "percentage") {
                              const relatedWageTypeIds = commonDatas
                                .filter((center) => center.CategoryId === wageData.CategoryId)
                                .map((center) => center.Id);

                              setWageData((prev) => ({
                                ...prev,
                                WageTypeId: relatedWageTypeIds,
                              }));
                            } else {
                              setWageData((prev) => ({
                                ...prev,
                                WageTypeId: null, // Set WageTypeId to null for "Amount"
                              }));
                            }
                          }}
                          className="border rounded p-2"
                          required
                        >
                          <option value="amount">Amount</option>
                          <option value="percentage">Percentage</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group flex flex-col">
                      <label>
                        Value <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="Amount"
                        name="Amount"
                        placeholder={wageData.Type === "amount" ? "Amount" : "Percentage"}
                        value={wageData.Amount}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Amount", value: e.target.value.trim() } });
                        }}
                      />
                    </div>


                    {wageData.Type === "percentage" && (
                      <>
                        {/* Wage Type Section */}
                        <div className="form-group flex flex-col col-span-2">
                          <label>
                          WageType
                          </label>
                          <div
                            className="mt-2"
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(2, 1fr)",
                              gap: "16px",
                            }}
                          >
                            {commonDatas.map((center, index) => (
                              <div
                                key={center.Id}
                                style={{
                                  padding: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  height: "60px",
                                  cursor: "pointer",
                                }}
                              >
                                <li
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    height: "60px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      flexShrink: 0,
                                      display: "flex",
                                      alignItems: "center",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={`leave${index + 1}`}
                                      name={`leave${index + 1}`}
                                      value={center.Id}
                                      checked={wageData.WageTypeId.includes(center.Id)}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        cursor: "pointer",
                                        margin: 0,
                                      }}
                                      onChange={(e) => {
                                        const updatedSelection = e.target.checked
                                          ? [...wageData.WageTypeId, center.Id]
                                          : wageData.WageTypeId.filter((id) => id !== center.Id);

                                        handleChange({
                                          target: {
                                            name: "WageTypeId",
                                            value: updatedSelection,
                                          },
                                        });
                                      }}
                                    />
                                  </div>
                                  <label
                                    htmlFor={`leave${index + 1}`}
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      cursor: "pointer",
                                      flex: "1",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {center.Name}
                                  </label>
                                </li>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Wage Component Section */}
                        <div className="form-group flex flex-col col-span-2">
                          <label>
                            Wage Component 
                          </label>
                          <div
                            className="mt-2"
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(2, 1fr)",
                              gap: "16px",
                            }}
                          >
                            {WgCompOptions.map((option, index) => (
                              <div
                                key={option.value}
                                style={{
                                  padding: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  height: "60px",
                                  cursor: "pointer",
                                }}
                              >
                                <li
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    height: "60px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      flexShrink: 0,
                                      display: "flex",
                                      alignItems: "center",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={`wageComponent${index + 1}`}
                                      name={`wageComponent${index + 1}`}
                                      value={option.value}
                                      checked={selectedValues.includes(option.value)}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        cursor: "pointer",
                                        margin: 0,
                                      }}
                                      onChange={handleChangeWgComponent}
                                    />
                                  </div>
                                  <label
                                    htmlFor={`wageComponent${index + 1}`}
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      cursor: "pointer",
                                      flex: "1",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {option.label}
                                  </label>
                                </li>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}


                    <div className="form-group flex flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={wageData.Narration}
                        onChange={handleChange}
                      />
                    </div>



                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </form>

            </div>
          </div>
          <div
            // onClick={openAddWageModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
      {editWageModal && (
        <>
          {/* ========================================================EDIT======================================================== */}

          <div className="fixed p-15 w-full max-w-[900px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Wage Component
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditWageModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>

              <form
                onSubmit={handleEdit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[70vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8"> {/* Two-column layout */}

                    <div className="form-group flex flex-col">
                      <label>
                        WageComponent <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={wageData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                        
                      />
                    </div>



                    <div className="form-group flex flex-col">
                      <label>
                        Component type <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="ComponentType"
                        value={wageData.ComponentType}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select Component Type
                        </option>
                        <option value="Deduction type">Deduction Type</option>
                        <option value="Addition type">Addition Type</option>
                      </select>
                    </div>



                    <div className="form-group flex flex-col"> {/* Full-width field */}
                      <label>
                        Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="mb-3">
                        <select
                          id="wageType"
                          name="Type"
                          value={wageData.Type}
                          onChange={(e) => {
                            const selectedType = e.target.value;
                            handleChange(e);

                            // Automatically set the WageTypeId when "Percentage" is selected
                            if (selectedType === "percentage") {
                              const relatedWageTypeIds = commonDatas
                                .filter((center) => center.CategoryId === wageData.CategoryId)
                                .map((center) => center.Id);

                              setWageData((prev) => ({
                                ...prev,
                                WageTypeId: relatedWageTypeIds,
                              }));
                            } else {
                              setWageData((prev) => ({
                                ...prev,
                                WageTypeId: null, // Set WageTypeId to null for "Amount"
                              }));
                            }
                          }}
                          className="border rounded p-2"
                          required
                        >
                          <option value="amount">Amount</option>
                          <option value="percentage">Percentage</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group flex flex-col">
                      <label>
                        Value <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="Amount"
                        name="Amount"
                        placeholder={wageData.Type === "amount" ? "Amount" : "Percentage"}
                        value={wageData.Amount}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Amount", value: e.target.value.trim() } });
                        }}
                        
                        
                      />
                    </div>

                    {wageData.Type === "percentage" && (
                      <div className="form-group flex col-span-2 flex-col gap-2">
                        <label>
                          Wage Type 
                        </label>
                        <div
                          className="mt-2"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "16px",
                          }}
                        >
                           {commonDatas.map((center, index) => (
                              <div
                                key={center.Id}
                                style={{
                                  padding: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  height: "60px",
                                  cursor: "pointer",
                                }}
                              >
                                <li
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    height: "60px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      flexShrink: 0,
                                      display: "flex",
                                      alignItems: "center",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={`leave${index + 1}`}
                                      name={`leave${index + 1}`}
                                      value={center.Id}
                                      checked={wageData.WageTypeId.includes(center.Id)}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        cursor: "pointer",
                                        margin: 0,
                                      }}
                                      onChange={(e) => {
                                        const updatedSelection = e.target.checked
                                          ? [...wageData.WageTypeId, center.Id]
                                          : wageData.WageTypeId.filter((id) => id !== center.Id);

                                        handleChange({
                                          target: {
                                            name: "WageTypeId",
                                            value: updatedSelection,
                                          },
                                        });
                                      }}
                                    />
                                  </div>
                                  <label
                                    htmlFor={`leave${index + 1}`}
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      cursor: "pointer",
                                      flex: "1",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {center.Name}
                                  </label>
                                </li>
                              </div>
                            ))}
                        </div>
                        
                    <div className="form-group flex flex-col col-span-2">
                      <label>
                        Wage Component 
                      </label>
                      <div
                        className="mt-2"
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2, 1fr)", // Adjust grid for Wage Component
                          gap: "16px",
                        }}
                      >
                        {WgCompOptions.map((option, index) => (
                          <div
                            key={option.value}
                            style={{
                              padding: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              height: "60px",
                              cursor: "pointer",
                            }}
                          >
                            <li
                              style={{
                                width: "100%",
                                padding: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                height: "60px",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  flexShrink: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "10px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id={`wageComponent${index + 1}`}
                                  name={`wageComponent${index + 1}`}
                                  value={option.value}
                                  checked={selectedValues.includes(option.value)}
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    cursor: "pointer",
                                    margin: 0,
                                  }}
                                  onChange={handleChangeWgComponent}
                                />
                              </div>
                              <label
                                htmlFor={`wageComponent${index + 1}`}
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  flex: "1",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {option.label}
                              </label>
                            </li>
                          </div>
                        ))}
                      </div>
                    </div>

                      </div>
                    )}


                    <div className="form-group flex flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={wageData.Narration}
                        onChange={handleChange}
                      />
                    </div>

                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataedit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </form>

            </div>
          </div>
          <div
            // onClick={openEditWageModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
